let searchWords = document
  .getElementById("predictive-search-drawer-input-words")
  .getAttribute("data-val");
let searchWordsArr = ["keywords.."];
if (searchWords.length > 0) {
  let tmpJson = JSON.parse(searchWords);
  //console.log(tmpJson);
  //console.log(typeof tmpJson.words);
  searchWordsArr =
    tmpJson != undefined && tmpJson.words != undefined
      ? tmpJson.words
      : ["keywords.."];
}
//console.log(searchWordsArr);
var typed = new Typed("#predictive-search-drawer-input", {
  strings: searchWordsArr,
  typeSpeed: 150,
  backSpeed: 60,
  backDelay: 3000,
  shuffle: false,
  loop: true,
  attr: "placeholder",
});
